import React from "react";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useTheme} from "@mui/material/styles"; // Import per accedere al tema
import {UtenteLogged} from "../../authentication/authenticationSlice";
import {
    ErrorStatusTypes,
    ErrorsStack,
    parseErrorMessage,
} from "../../common/errorsDeclarations";
import SignIn from "../../authentication/SignIn";
import CircularProgress from "@mui/material/CircularProgress";

import home_img from "../../../../static/images/common/hero-systel.png";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";

import HomeMenu from "./HomeMenu";

const HomePage = () => {
    const utente = useSelector<RootState, UtenteLogged>(
        (state) => state.authentication.utenteLogged
    );


    return (
        <Grid
            container
            sx={{flexGrow: 1, mb: 1}}
            rowSpacing={1}
            columnSpacing={{xs: 1, sm: 2, md: 3}}
            justifyContent="center"
            alignItems="center"
        >
            <Grid size={{xs: 12, sm: 12, md: 12, lg: 12}}>
                {utente.errorsStack.status == ErrorStatusTypes.PENDING ? (
                    <Box>
                        <CircularProgress size={100} color="info"/>
                    </Box>
                ) : utente.isLogged ? (
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            justifyContent: "space-around",
                            alignItems: "center",
                        }}
                    >
                        <Grid
                            size={{xs: 12, md: 8, lg:4}}
                        >
                            <HomeMenu/>
                        </Grid>
                        <Grid size={{xs: 0, md: 4, lg:4}}>
                            <Card raised>
                                <CardMedia
                                    component="img"
                                    image={home_img}
                                    // height="430"
                                    sx={{
                                        objectFit: "cover",
                                        // objectPosition: "50% 0%",
                                    }}
                                    alt="Azienda Evop"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h4">
                                        Claire - Pianificazione della Produzione
                                    </Typography>
                                    <Typography gutterBottom>
                                        Systel Elettronica
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                ) : (
                    <SignIn/>
                )}
            </Grid>


        </Grid>
    );
};

export default HomePage;
